import React from 'react';

const RmbPaymentBar = ({ onPay }) => {
  return (
    <div
      className="rmb-payment"
      style={{
        margin: '20px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8
      }}
    >
      <div
        className="rmb-label"
        style={{ fontSize: 14, color: '#f5f5f5', display: 'flex', alignItems: 'center', gap: 4 }}
      >
        人民币支付 <span>👉</span>
      </div>
      <div
        className="rmb-buttons"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          background: '#ffffff',
          borderRadius: 999,
          padding: '4px 6px',
          gap: 4
        }}
      >
        <button
          type="button"
          className="rmb-button wechat"
          onClick={onPay}
          style={{
            width: 24,
            height: 24,
            borderRadius: 4,
            border: 'none',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'transparent',
            cursor: 'pointer'
          }}
        >
          <img
            src="/wechatpay.svg"
            alt="WeChat Pay"
            style={{ width: 18, height: 18, display: 'block' }}
          />
        </button>
        <button
          type="button"
          className="rmb-button alipay"
          onClick={onPay}
          style={{
            width: 32,
            height: 24,
            borderRadius: 4,
            border: 'none',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'transparent',
            cursor: 'pointer'
          }}
        >
          <img
            src="/alipay.svg"
            alt="Alipay"
            style={{ width: 20, height: 20, display: 'block' }}
          />
        </button>
      </div>
    </div>
  );
};

export default RmbPaymentBar;
